function initializeProduct(section) {
  if (section.dataset.initialized) return;
  section.dataset.initialized = "true";
  const gallery = section.querySelector("[data-product-gallery]");
  if (gallery) {
    gallery.addEventListener("click", (event) => {
      const thumb = event.target.closest("[data-gallery-thumb]");
      if (!thumb || !gallery.contains(thumb)) return;
      const mainImage = gallery.querySelector("[data-gallery-main]");
      if (!mainImage) return;
      mainImage.src = thumb.dataset.imageUrl;
      mainImage.alt = thumb.dataset.imageAlt || "Product image";
      gallery.querySelectorAll("[data-gallery-thumb]").forEach((button) => {
        const selected = button === thumb;
        button.setAttribute("aria-pressed", String(selected));
        button.classList.toggle("is-selected", selected);
      });
    });
  }
  const variantSelect = section.querySelector("[data-variant-select]");
  if (!variantSelect) return;
  const updateVariant = () => {
    const option = variantSelect.selectedOptions[0];
    const available = option.dataset.available === "true";
    section.querySelector("[data-product-price]").textContent =
      option.dataset.price;
    const installmentPrice = section.querySelector("[data-installment-price]");
    if (installmentPrice && option.dataset.installmentPrice) {
      installmentPrice.textContent = option.dataset.installmentPrice;
    }
    const comparePrice = section.querySelector("[data-compare-price]");
    comparePrice.textContent = option.dataset.comparePrice;
    comparePrice.hidden = !option.dataset.comparePrice;
    const button = section.querySelector("[data-add-to-cart]");
    button.disabled = !available;
    button.textContent = available ? "Add to bag" : "Sold out";
    section.querySelector("[data-availability]").textContent = available
      ? "Available"
      : "Sold out";
    section.querySelector("[data-payment-button]").hidden = !available;
    const quantity = section.querySelector("[data-product-quantity]");
    quantity.min = option.dataset.quantityMin || "1";
    quantity.step = option.dataset.quantityStep || "1";
    if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
    else quantity.removeAttribute("max");
    quantity.value = quantity.min;
    const url = new URL(window.location.href);
    url.searchParams.set("variant", option.value);
    window.history.replaceState({}, "", url);
  };
  variantSelect.addEventListener("change", updateVariant);
}

function initializeSections(root = document) {
  root.querySelectorAll("[data-product-section]").forEach(initializeProduct);
}

initializeSections();
document.addEventListener("shopify:section:load", (event) =>
  initializeSections(event.target),
);

let scrollScheduled = false;
window.addEventListener(
  "scroll",
  () => {
    if (scrollScheduled) return;
    scrollScheduled = true;
    requestAnimationFrame(() => {
      document
        .querySelector("[data-site-header]")
        ?.classList.toggle("is-scrolled", window.scrollY > 40);
      if (!window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
        document.querySelectorAll("[data-stars]").forEach((stars) => {
          stars.style.backgroundPositionY = `${window.scrollY * 0.12}px`;
        });
      }
      scrollScheduled = false;
    });
  },
  { passive: true },
);
